import React from 'react'
//import { useGetEntityForm } from './hooks'
import { useGetEntityForm } from '../../hooks/entityFormHook'
import {
  Box,
  Container,
  Typography,
} from '@mui/material'
import { Fetching } from '../../components/Fetching'
import { Form } from '../../components/Form'

export const EntityForm = () => {
  const { data, isFetching, error } = useGetEntityForm('projectForm', '123')

  if (isFetching) {
    return <Fetching />
  }

  if (error) {
    return <>
      Oops, can't load entity form
    </>
  }

  return <>
    {
      data && <>
        <Box sx={{ paddingLeft: '100px', paddingRight: '100px' }}>
          <Container maxWidth='lg'>
            <Typography variant='h3' gutterBottom>{data.formName}</Typography>
            <Form
              fields={data.fields} />
          </Container>
        </Box>
      </>
    }
  </>
}